export enum StatusCasesV2 {
    Created = "created",
    InProgress = "in_progress",
    Done = "done",
    ExternallyHandled = "managed_externally",
    // Status in API is only a string value, so we need to set it to unknown if we get an unsupported status somehow
    Unknown = "unknown",
}
